@if ((activeAuction$ | async); as activeAuction) {

  @if (activeAuction.secondsLeft > 0 || !activeAuction.settled) {
    <div class="bid-info">
      <div class="bid-info-item">
        <div class="label">Bids</div>
        <div class="value">{{ activeAuction.events.length || 0 }}</div>
      </div> 

      <div class="bid-info-item current-bid">
        <div class="label">{{ activeAuction.secondsLeft > 0 ? 'Latest Bid' : activeAuction.events.length ? 'Highest Bid' : 'Closing Bid' }}</div>
        <div class="value">

          <span class="eth-symbol">Ξ</span>{{ (activeAuction.bid ? 
            activeAuction.bid.value : 
              activeAuction.events.length ? 
              activeAuction.events[0].value : '0') | wei | number : '1.0-4' }}

        </div>
      </div>

      <div class="bid-info-item time-remaining">
        <div class="label">Est. Time Remaining</div>
        <div class="value">
          <app-timer
            [endTime]="activeAuction.endTime"
            (event)="handleEvent($event)"
          />
        </div>
      </div>
    </div>
  }

  <div
    class="form-wrapper"
    [class]="themeSvc.theme$ | async"
    [class.complete-active]="activeAuction.blocksRemaining < 0"
    [class.connect-active]="!(stateSvc.web3Connected$ | async)">

    <div class="connect">
      <button (click)="web3Svc.connect()">

        Connect your wallet to interact with this auction
      </button>
    </div>

    <div class="auction-closed">
      <p>There is no active auction for this Punk.</p>
    </div>

    <form onSubmit="return false">
      <div class="input-wrapper">
        @if (activeAuction.blocksRemaining > 0) {
          <input
            type="number"
            [formControl]="bidValue"
            [placeholder]="'> Ξ' + ((
              activeAuction.bid ? 
              activeAuction.bid.value : 
                activeAuction.events.length ? 
                activeAuction.events[0].value : '0'
            ) | wei | number : '1.0-4')"
            [style.backgroundColor]="'rgba(' + (themeSvc.activeBackground$ | async) + ', .2)'"
          />
        } @else {
          <div class="input-placeholder">&nbsp;</div>
        }
        <div
          class="info"
          tippy
          [attr.data-tippy-content]="'AUCTION BIDS USE THE SAME CONTRACT INTERACTION AS REGULAR BIDS ON THE MARKETPLACE.'"
          [attr.data-tippy-position]="'top'">

          <svg height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg"><path d="m16 24v2h-6v-2zm4-2v2h-4v-2zm-10 0v2h-4v-2zm12-2v2h-2v-2zm-16 0v2h-2v-2zm18-4v4h-2v-4zm-20 0v4h-2v-4zm10 0v2h-2v-2zm12-6v6h-2v-6zm-24 0v6h-2v-6zm14 2v2h-4v-2zm-6-2v2h-2v-2zm8 0v2h-2v-2zm6-4v4h-2v-4zm-20 0v4h-2v-4zm12 2v2h-6v-2zm6-4v2h-2v-2zm-16 0v2h-2v-2zm4-2v2h-4v-2zm10 0v2h-4v-2zm-4-2v2h-6v-2z" fill-rule="evenodd" fill="rgba(var(--text-color), 1)" /></svg>
        </div>
      </div>

      <button
        (click)="submitBid(activeAuction.punkId)"
        type="submit">

        Place Bid
      </button>
    </form>
  </div>

  <div
    class="error"
    [class.active]="errorMessage?.length">

    <button (click)="closeError()">x</button>

    Error: {{ errorMessage }}
  </div>

  <div
    class="transaction"
    [class.active]="txHash">

    <button (click)="closeTransaction()">x</button>

    Your transaction is pending.<br /><a [href]="'https://goerli.etherscan.io/tx/' + txHash" target="_blank">View it on etherscan<svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="rgba(var(--text-color), .5)" /></svg></a>
  </div>

  <!-- <pre>{{ activeAuction$ | async | json }}</pre> -->

  @if (activeAuction.secondsLeft > 0 || !activeAuction.settled) {
    <app-bid-history [activeAuction]="activeAuction" />
  }
}
